module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-2.413622a5.webp";